import React from 'react'
import { makeStyles } from "@material-ui/core/styles";
import { IconChecklist } from '@tabler/icons';

const useStyles = makeStyles((theme) => ({
    contenedorEncabezado: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'left',
        alignItems: 'center',
        marginBottom:"17px",
        marginTop:"30px",
    },
    circuloIcono: {
        width: '30px',
        height: '30px',
        borderRadius: '50%',
        backgroundColor: "#F77F00",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        marginRight: "5px",
        padding:"1px"
    },
    iconoEncabezado: {
        color:"white", 
        fontSize:"1.4rem",
    },
    miTitulo:{
      fontSize:"1.1rem",
      color:"black"
    },
    espacio: {
      padding: "50px"
  }
  }));

const EncabezadoTipoCarga = () => {
    const styles = useStyles();
  return (
    <div className={styles.contenedorEncabezado}>
        <div className={styles.circuloIcono}>
            <IconChecklist
              size={23}
              color="white"
              stroke={2}
              className={styles.iconoEncabezado}
            />
        </div>  
        <h6 className={styles.miTitulo}>Seleccionar tipo de carga</h6>
    </div>
  )
}

export default EncabezadoTipoCarga;